import { parseAbi } from 'viem';
import { LEGACY } from './registry';
// B1 only. No director target, claim, deposit, approval, or NFT methods.
export const PTT_EXIT_ADDRESS = LEGACY.team;
export const PTT_CODE_HASH = '0x1c142a2fb51ea3799299c6282afaed9d82c1f63b056867710186ed317fcb7525';
export const PTT_EXIT_ABI = parseAbi(['function withdraw(uint256 amount)']);
export const PTT_EXIT_EVENT = parseAbi(['event WithdrawLog(address indexed acount,uint256 amount)']);
export const PTT_READ_ABI = parseAbi([
  'function balanceOf(address) view returns(uint256)', 'function balanceOfShares(address) view returns(uint256)',
  'function balanceOfAvailable(address) view returns(uint256)', 'function decimals() view returns(uint8)',
]);
